import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import React from 'react';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';
import { useSIPControl } from 'features/toolbar/toolbar/controls/sip/useSIPControl';
import { SIPConnectedBadgeColor } from 'features/sip/constants';

const SIPControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { icon, isFeatureAvailable, toggleConnectionModal, label, status } = useSIPControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    toggleConnectionModal();
  };

  return (
    <ToolbarMenuItem
      id="sip"
      overlay={label}
      ariaLabel={label}
      icon={icon}
      onClick={handleClick}
      badgeActive
      BadgeProps={{
        invisible: status !== 'connected',
        variant: 'dot',
        color: SIPConnectedBadgeColor as any,
      }}
    />
  );
};

export default SIPControl;
